module.exports = __webpack_public_path__ + "img/icon_clear.32a78c9f.png";